import { Dispatch, SetStateAction } from 'react';
import { DataSourcesTypes } from '@frontend/api-data-sources';
import { PersonTypes } from '@frontend/api-person';
import { UsePopoverDialogResponse } from '@frontend/design-system';

export enum PatientSelectorScreenEnum {
  PERSON_SEARCH = 'PERSON_SEARCH',
  PERSON_NOTES = 'PERSON_NOTES',
  CUSTOM_CONTACT = 'CUSTOM_CONTACT',
}

export type PersonLastNameLetterMap = {
  [letter: string]: string[];
};

type AtLeastOne<T, U = { [K in keyof T]: Pick<T, K> }> = Partial<T> & U[keyof U];

type FieldName =
  | 'firstName'
  | 'lastName'
  | 'dateOfBirth'
  | 'gender'
  | 'email'
  | 'source'
  | 'phoneNumber'
  | 'notes'
  | 'clientLocationId'
  | 'street'
  | 'city'
  | 'country'
  | 'state'
  | 'postalCode';

type Fields<T extends string> = AtLeastOne<{
  [key in T]: {
    value: string;
    required?: boolean;
  };
}>;

export type FormFields = Fields<FieldName>;
export type PersonSelectorFormValues = AtLeastOne<{
  [key in FieldName]: string;
}> & { personId?: string };

export type AddToListHandlerParamsType = Pick<PersonSelectorFormValues, 'personId' | 'notes'> & { isNew?: boolean };

export type PersonSelectorPropsType = {
  setSelectedPerson: Dispatch<SetStateAction<TransformedLegacyPerson | null>>;
  formFields: FormFields;
  personSelectorScreen: PatientSelectorScreenEnum;
  setPersonSelectorScreen: Dispatch<SetStateAction<PatientSelectorScreenEnum>>;
  clientLocationIds?: DataSourcesTypes.AccessDataResponse['ClientLocations'];
};

export type UsePersonSelectorReturnType = {
  selectedPerson: PersonTypes.Person | null;
  personSelectorDialogProps: UsePopoverDialogResponse;
  personSelectorProps: PersonSelectorPropsType;
};

export interface TransformedLegacyPerson extends PersonTypes.Person {
  SourceTenantID?: string;
}
